import type { AvailabilityStatus, ShiftLabel } from './types';

// Mirrors MAX_BULK_DATES in apps/mcv-api/mcv_api/routes/provider_calendar/service/_shared.py.
// The bulk mark/clear endpoints 400 above this count, so the client refuses a
// selection that would exceed it instead of sending a request the server
// will reject.
export const MAX_BULK_DATES = 366;

export const SHIFT_TEMPLATES: Record<ShiftLabel, { endTime: string; startTime: string }> = {
  DAY: { startTime: '07:00', endTime: '15:00' },
  EVENING: { startTime: '15:00', endTime: '23:00' },
  NIGHT: { startTime: '23:00', endTime: '07:00' },
  CUSTOM: { startTime: '08:00', endTime: '17:00' },
};

export const WEEKDAYS = [
  { label: 'Mon', bit: 0 },
  { label: 'Tue', bit: 1 },
  { label: 'Wed', bit: 2 },
  { label: 'Thu', bit: 3 },
  { label: 'Fri', bit: 4 },
  { label: 'Sat', bit: 5 },
  { label: 'Sun', bit: 6 },
] as const;

export const STATUS_LABEL: Record<AvailabilityStatus, string> = {
  AVAILABLE: 'Available',
  HELD: 'Held',
  BOOKED: 'Booked',
  UNAVAILABLE: 'Unavailable',
};

// [MCV-1821] A contract start is not an availability status: it gets its own solid token style
// so it never reads as Available / Held / Booked / Unavailable.
export const CONTRACT_START_LEGEND_LABEL = 'Contract start';
export const CONTRACT_START_STYLES = 'bg-primary-50 text-white';

export const STATUS_STYLES: Record<AvailabilityStatus, string> = {
  AVAILABLE: 'bg-success-subtle text-good',
  HELD: 'bg-warning-50 text-warning-950',
  BOOKED: 'bg-primary-t-900 text-primary-50',
  UNAVAILABLE: 'bg-grey-900 text-grey-400',
};
